import { css } from 'styled-system/css';

export const appDownloadStyles = {
	banner: css({
		base: {
			'--primary-h': {
				base: '223',
				_site42018: '223', // Macaubet
				_site42021: '350', // Aoncash
				_site42024: '213', // ITCBet
				_site42156: '0', // Bolanation
				_site42063: '213', // 9bet
				_site42094: '110', // M8Bola
				_site42102: '17'  // Q8bola
			},
			position: 'relative',
			padding: '9px 15px',
			background: 'linear-gradient(90deg, hsl(var(--primary-h), 57%, 17%) 0%, hsl(var(--primary-h), 53%, 35%) 100%)',
			color: '#E9C38D',
			'&::before': {
				content: '""',
				display: 'block',
				position: 'absolute',
				top: 0,
				right: 0,
				bottom: 0,
				left: 0,
				backgroundColor: 'hsl(var(--primary-h), 72%, 52%)',
				maskImage: 'url(/images/sign-up/download-mask-bar.png)',
				maskPosition: 'right',
				maskSize: '100% 100%',
				maskRepeat: 'no-repeat',
			}
		},
	}),
	bannerBg: css({
		base: {
			aspectRatio: '5.99',
			objectFit: 'fill',
			objectPosition: 'center',
			width: '100%',
			position: 'absolute',
			zIndex: 0,
			left: 0,
			right: 0,
			bottom: 0,
			height: '60px',
		}
	}),
	bannerContent: css({
		base: {
			zIndex: 1,
			display: 'flex',
			width: '100%',
			alignItems: 'center',
			gap: '12px',
			height: '100%',
			padding: '0 6px',
			
		}
	}),
	closeIcon: css({
		base: {
			cursor: 'pointer',
			zIndex: 1,
			'& .icon': {
				color: 'jupiter.common.white',
			}
		}
	}),
	appIcon: css({
		base: {
			aspectRatio: '1',
			objectFit: 'contain',
			objectPosition: 'center',
			width: '24px',
			borderRadius: '24px',
			alignSelf: 'stretch',
			margin: 'auto 0',
		}
	}),
	appLogo: css({
		base: {
			zIndex: 1,
			objectFit: 'contain',
			objectPosition: 'center',
			width: '45px',
			alignSelf: 'stretch',
			margin: 'auto 0',
		}
	}),
	appInfo: css({
		base: {
			zIndex: 1,
			fontSize: '14px',
			color: 'jupiter.common.white',
			fontWeight: 700,
			margin: 'auto 0',
		}
	}),
	appLabel: css({
		base: {
			w: 'auto',
			display: 'inline-flex',
			alignItems: 'center',
			position: 'relative',
			padding: '1px 12px 1px 5px',
			boxSizing: 'border-box',
			fontSize: '10px',
			fontWeight: 'bold',
			fontStyle: 'italic',
			textAlign: 'center',
			textTransform: 'uppercase',
			lineHeight: 1,
			minWidth: '40px',
			backgroundImage: 'linear-gradient(to right, #FF4040, #D90000, #FF4040, #D90000)',
			backgroundSize: '300% 100%',
			maskImage: 'url(/images/sign-up/new-label.png)',
			maskRepeat: 'no-repeat',
			maskSize: '100% 100%',
		}
	}),
	appDescription: css({
		base: {
			marginTop: '6px',
		}
	}),
	downloadButton: css({
		base: {
			alignSelf: 'stretch',
			borderRadius: '20px',
			border: '1px solid #e9c38d',
			background: '#000',
			padding: '6px 12px',
			fontSize: '12px',
			color: '#e9c38d',
			fontWeight: 400,
			whiteSpace: 'nowrap',
			lineHeight: 1,
			margin: 'auto 0 auto auto',
			cursor: 'pointer',
			zIndex: 5
		}
	}),
}